import React from 'react'

export default function Input ({ error = false, className = '', ...props }) {
  return <input className={`ui-input ${className}`.trim()} aria-invalid={error || undefined} {...props} />
}
